import { render } from "./BrandFetcher.vue?vue&type=template&id=55a392a9&scoped=true"
import script from "./BrandFetcher.vue?vue&type=script&lang=js"
export * from "./BrandFetcher.vue?vue&type=script&lang=js"

import "./BrandFetcher.vue?vue&type=style&index=0&id=55a392a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a392a9"]])

export default __exports__